export default "__VITE_ASSET__r3sI9d1A__"